// ITU-T CRC-16 (x^16 + x^12 + x^5 + 1) as used by the WHP 198 studio signal.
//
// WHP 198 §3 / Appendix B: the registers are preset to 1s, the CRC bytes are
// zeroed, and all 128 bits are clocked through. That augmented form is
// identical to a direct (non-augmented) CCITT CRC preset to 0x1D0F over the
// first 14 bytes, which is what this computes. Running the same CRC over all
// 16 bytes (data + CRC) gives 0x0000 when there are no errors.

const POLY = 0x1021;
export const CRC_INIT = 0x1d0f;

const TABLE = new Uint16Array(256);
for (let i = 0; i < 256; i++) {
    let crc = i << 8;
    for (let bit = 0; bit < 8; bit++) {
        crc = crc & 0x8000 ? (crc << 1) ^ POLY : crc << 1;
    }
    TABLE[i] = crc & 0xffff;
}

/**
 * @param {ArrayLike<number>} bytes
 * @param {number} [init]
 * @returns {number} 16-bit CRC
 */
export function crc16(bytes, init = CRC_INIT) {
    let crc = init;
    for (let i = 0; i < bytes.length; i++) {
        crc = ((crc << 8) ^ TABLE[((crc >> 8) ^ bytes[i]) & 0xff]) & 0xffff;
    }
    return crc;
}
